import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import Elimination from "./Elimination";
import LineupRequirements from "./LineupRequirements";



const ScoringRulesnba = (props) => {
    const [defaultAccordion, setDefaultAccordion] = useState(props.defaultAccordion);
    const score_type_code = props.scoringRule ? props.scoringRule: 'S';
    return (
         <Accordion defaultActiveKey={defaultAccordion} className="rules-accordion">
                                

                                <Elimination/> 

                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Scoring Rules</Accordion.Header>
                                    <Accordion.Body>
                                      <div className="scoring-data rules-card-data">
                                            <div className="player-position">
                                                <h4>NBA SCORE</h4>
                                                <div className="info-block">
                                                    <h5>{(score_type_code === 'S') ? 'STANDARD' : 'PAR (Points/Assists/Rebounds)'} </h5>
                                                    <p>Points:  1 points </p>
                                                    <p>Assists:  {(score_type_code === 'P') ? '1 points' : '1.5 points'}</p>
                                                    <p>Rebounds:  {(score_type_code === 'P') ? '1 points' : '1.5 points'}</p>
                                                   {(score_type_code === 'S') ?  <><p>Turnovers:  -1 points</p>
                                                    <p>Blocks:  3 points</p>
                                                    <p>Steals:   3 points</p></> : ''}
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </Accordion.Body>
                                </Accordion.Item>

                                <LineupRequirements/>
                              
                            </Accordion>

    )
}

export default ScoringRulesnba

